import React from 'react'
import './Common_Title_2.css'

const Common_Title_2 = ({titleText, subText}) => {
  return (
    <div className='Common_Title_2'>
        <p className='title_text'>{titleText}</p>
        <div className='botoom_title_div'>
            <img src='/assets/images/header/left.png' className='left_img' />
            <p className='sub_text'>{subText}</p>
            <img src='/assets/images/header/right.png' className='right_img' />
        </div>
        
    </div>
  )
}

export default Common_Title_2
